import { add, rotate, sub, type Vec2 } from './vec.js';

/** Planar placement: position of the local origin and counter-clockwise rotation (rad). */
export interface Placement2 {
  readonly position: Vec2;
  readonly rotation: number;
}

export function localToWorld(local: Vec2, placement: Placement2): Vec2 {
  return add(rotate(local, placement.rotation), placement.position);
}

export function worldToLocal(world: Vec2, placement: Placement2): Vec2 {
  return rotate(sub(world, placement.position), -placement.rotation);
}
